module.exports = __webpack_public_path__ + "static/media/Acrilico (24).18dd3c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (24).jpg
// module id = 292
// module chunks = 0